import { TEMPLATE_TYPE } from '../../../../constants/messageTemplateKeys';
import { RadioCardGroup } from './RadioCardGroup';

const TYPE_OPTIONS = [
  { value: TEMPLATE_TYPE.MARKETING, label: 'Marketing' },
  { value: TEMPLATE_TYPE.TRIGGER, label: 'Trigger' },
];

export function TypeSelector({ type, onTypeChange }) {
  return (
    <RadioCardGroup
      label="Type"
      ariaLabel="Template Type"
      options={TYPE_OPTIONS}
      value={type === TEMPLATE_TYPE.TRIGGER ? TEMPLATE_TYPE.TRIGGER : TEMPLATE_TYPE.MARKETING}
      onChange={onTypeChange}
    />
  );
}
